import Vue from "vue";
import Vuex from "vuex";
import VuexPersistence from "vuex-persist";

Vue.use(Vuex);

// Setup : VuexPersistence
const vuexLocal = new VuexPersistence({
  storage: window.localStorage
});

export default new Vuex.Store({
  state: {
    userProfile: {},
    wsError: "",
    wsMessage: "",
    wsConnected: false
  },
  mutations: {
    SET_USER_PROFILE: (state, value) => {
      state.userProfile = value;
    },
    SOCKET_CONNECT(state) {
      state.wsConnected = true;
    },
    SOCKET_DISCONNECT(state) {
      state.wsConnected = false;
    },
    SOCKET_MESSAGE(state, message) {
      state.wsMessage = message;
    },
    SOCKET_ERROR(state, message) {
      state.wsError = message.error;
    }
  },
  actions: {},
  plugins: [vuexLocal.plugin]
});
